import React, { useState, useEffect } from 'react';
import { Eye, RefreshCw } from 'lucide-react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const LiveViewers = () => {
  const [viewers, setViewers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastRefresh, setLastRefresh] = useState(new Date());

  useEffect(() => {
    fetchViewers();
    const interval = setInterval(fetchViewers, 15000);
    return () => clearInterval(interval);
  }, []);

  const fetchViewers = async () => {
    try {
      const res = await api.get('/api/channels/live/viewers');
      setViewers(res.data.data || []);
      setLastRefresh(new Date());
    } catch (err) {
      toast.error('Failed to load live viewers');
    } finally {
      setLoading(false);
    }
  };

  const timeAgo = (ts) => {
    const secs = Math.floor((new Date() - new Date(ts)) / 1000);
    if (secs < 60) return `${secs}s ago`;
    return `${Math.floor(secs / 60)}m ago`;
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Live Viewers</div>
          <div className="page-subtitle">{viewers.length} watching right now &middot; auto-refreshes every 15s</div>
        </div>
        <button className="btn btn-secondary" onClick={fetchViewers}>
          <RefreshCw size={16} /> Refresh
        </button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        {loading ? (
          <div className="loading"><div className="spinner" />Loading...</div>
        ) : viewers.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px', color: 'var(--text-secondary)' }}>
            <Eye size={32} style={{ marginBottom: '12px', opacity: 0.4 }} />
            <div>No one is currently watching</div>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Channel</th>
                <th>Platform</th>
                <th>Watching Since</th>
                <th>Last Activity</th>
                <th>IP Address</th>
              </tr>
            </thead>
            <tbody>
              {viewers.map((v, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: '500' }}>{v.full_name || v.username || '—'}</td>
                  <td>{v.channel_name || '—'}</td>
                  <td>
                    <span className={`badge ${v.source === 'xtream_tv' ? 'badge-info' : 'badge-success'}`}>
                      {v.source === 'xtream_tv' ? 'Tizen/webOS' : 'App'}
                    </span>
                  </td>
                  <td style={{ fontSize: '13px' }}>{new Date(v.started_at).toLocaleTimeString('en-IN')}</td>
                  <td style={{ fontSize: '13px', color: '#00d4aa' }}>{timeAgo(v.last_seen)}</td>
                  <td style={{ fontFamily: 'monospace', fontSize: '12px', color: 'var(--text-secondary)' }}>{v.ip_address || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default LiveViewers;
